import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=627040fd&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('627040fd')) {
      api.createRecord('627040fd', component.options)
    } else {
      api.reload('627040fd', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=627040fd&", function () {
      api.rerender('627040fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y8fNzgd9weJ3/JS/pricehelp.vue"
export default component.exports